import { useRef, useState } from "react";
import classnames from "classnames";
import useOnClickOutside from "utils/useOnClickOutside";

import styles from "./NotesCard.module.scss";

const NotesCard = ({ className, notes }) => {
  const ref = useRef()
  const [open, setOpen] = useState(false);

  useOnClickOutside(ref, () => setOpen(false));

  return (
    <div
      className={classnames(className, styles.wrapper, open ? styles.open : "")}
      style={{ minHeight: '6.1rem' }}
      onClick={() => setOpen(!open)}
      ref={ref}
    >
      <p className={styles.value}>
        <span className={styles.title}>Notes: </span>
        {notes}
      </p>
    </div>
  );
};

export default NotesCard;
